module.exports = __webpack_public_path__ + "static/media/compound.cd1cf9f5.svg";